import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { useRouter } from 'next/router';

import { NextPageProgressBarBase } from '@/common/components/NextPageProgressBar/NextPageProgressBar.styled';

const NextPageProgressBar: FC = () => {
  const router = useRouter();
  const [progress, setProgress] = useState(0);
  const [isDone, setIsDone] = useState(false);
  const interval = useRef<NodeJS.Timeout | null>(null);

  const handleRouteChangeStart = useCallback(() => {
    setIsDone(false);
    setProgress(20);

    interval.current = setInterval(() => {
      setProgress((prevProgress) => (prevProgress < 100 ? prevProgress + 10 : prevProgress));
    }, 1500);
  }, []);

  const handleRouteChangeComplete = useCallback(() => {
    setProgress(100);
    setIsDone(true);
    if (interval.current) clearInterval(interval.current);

    const timeout = setTimeout(() => {
      setProgress(0);
      clearTimeout(timeout);
    }, 400);
  }, []);

  useEffect(() => {
    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.events.on('routeChangeComplete', handleRouteChangeComplete);
    router.events.on('routeChangeError', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
      router.events.off('routeChangeError', handleRouteChangeComplete);
    };
  }, [handleRouteChangeComplete, handleRouteChangeStart, router.events]);

  return <NextPageProgressBarBase isDone={isDone} percentage={progress} />;
};

export default NextPageProgressBar;
